import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20flat%20lay%20of%20carefully%20selected%20lifestyle%20products%20including%20a%20cream%20knit%20sweater%2C%20tan%20leather%20sneakers%2C%20a%20woven%20basket%20bag%2C%20and%20a%20ceramic%20vase%20with%20dried%20flowers%20on%20a%20warm%20textured%20linen%20surface%2C%20soft%20morning%20sunlight%2C%20organic%20natural%20composition%2C%20elevated%20minimalist%20aesthetic%2C%20editorial%20product%20photography&width=1800&height=1200&seq=hero-main-v3&orientation=landscape"
          alt="Curated Pandabuy Spreadsheet fashion collection"
          title="Pandabuy Spreadsheet - Curated Fashion Finds"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-6 border border-background-50/20">
          Updated Daily · 50,000+ Products Curated
        </span>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4 max-w-3xl mx-auto">
          {t("hero.title")}
        </h1>

        <p className="text-sm md:text-base text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t("hero.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("cta.pandabuy")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 font-medium text-sm hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("cta.buynow")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <p className="mt-10 text-xs md:text-sm text-background-50/65 max-w-2xl mx-auto leading-relaxed">
          {t("hero.intro")}
        </p>
      </div>
    </section>
  );
}